"use client";

import { useSession } from "next-auth/react";
import { useEffect, useState, type ReactNode } from "react";
import { WalesBetaAnalyticsContextProvider } from "~/app/lib/analytics/WalesBetaAnalyticsContext";
import {
  initializeWalesBetaAnalytics,
  isWalesBetaAnalyticsEligible,
  resetWalesBetaAnalytics,
} from "~/app/lib/analytics/walesBetaAnalytics";
import { api } from "~/trpc/react";

export default function PostHogProvider({ children }: { children: ReactNode }) {
  const { data: session, status } = useSession();
  const [enabled, setEnabled] = useState(false);
  const { data: features } = api.user.getFeatures.useQuery(undefined, {
    enabled: status === "authenticated",
    staleTime: 60_000,
  });

  const membershipId = session?.user.membershipId;
  const eligible = isWalesBetaAnalyticsEligible({
    authenticated: status === "authenticated",
    membershipId,
    walesEnabled: features?.wales_2026 === true,
  });

  useEffect(() => {
    if (!eligible || !membershipId) {
      resetWalesBetaAnalytics();
      setEnabled(false);
      return;
    }

    setEnabled(initializeWalesBetaAnalytics(membershipId));

    return () => {
      resetWalesBetaAnalytics();
    };
  }, [eligible, membershipId]);

  return (
    <WalesBetaAnalyticsContextProvider enabled={enabled}>
      {children}
    </WalesBetaAnalyticsContextProvider>
  );
}
